import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

const CardWithTable = ({ title, data, type }: any) => {
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;

  return (
    <div style={{ backgroundColor: "#fff", marginRight: "20px" }}>
      <div
        style={{
          fontSize: "20px",
          padding: "15px",
          borderBottom: "1px solid #eeeff2",
        }}
      >
        {title}
      </div>
      {data.length > 0 ? (
        <div>
          <TableContainer>
            <Table>
              <TableBody>
                {data.map((row: any, index: any) => (
                  <TableRow key={index}>
                    <TableCell sx={{ fontWeight: "500", borderBottom: "none" }}>
                      {row.name}
                    </TableCell>
                    <TableCell sx={{ width: "300px", borderBottom: "none" }}>
                      <LinearProgress
                        variant="determinate"
                        value={row.percentage}
                        sx={{
                          width: "100%",
                          height: "15px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#f7f7f7",
                          "& .MuiLinearProgress-bar1Determinate": {
                            backgroundColor: `#3baff6`,
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell style={{ borderBottom: "none" }}>
                      {row.percentage}%
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <div
          style={{
            padding: "50px 15px",
            textAlign: "center",
            color: "#777",
            fontSize: "18px",
          }}
        >
          <div style={{ alignItems: "center" }}>
            {type === "module"
              ? "We couldn't find any activity engagement data."
              : `At the moment, we're gathering insights on the reading preferences of ${access_code? "employees":"users"}.`}
          </div>
          <div>
            {type === "module"
              ? `Encourage ${access_code? "employees":"users"} to participate more!`
              : `Encourage ${access_code? "employees":"users"} to explore our blog categories and broaden their knowledge. Stay tuned as we gather insights to tailor our blog content to your interests.`}
          </div>
        </div>
      )}
    </div>
  );
};

export default CardWithTable;
